/**
 * @file The Form component.
 * @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { FormBase } from '../../base/form/form.base';
import { DomainService, PROP_ORIGINAL_RESOURCE_OID } from '../../domain.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertsService } from '../../core/alerts.service';
import { SettingsService } from '../../settings.service';
import { UserService } from '../../user.service';
import { ResourceService } from '../../resource.service';
var FormComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FormComponent, _super);
    function FormComponent(userService, domainService, route, router, translateService, alertsService, settingsService, resourceService) {
        var _this = _super.call(this, domainService, route, router, translateService, alertsService, resourceService) || this;
        _this.userService = userService;
        _this.settingsService = settingsService;
        _this.draftAlert = false;
        return _this;
    }
    /**
     * Save all the made changes. This method is used in the "edit" mode.
     * @param event The HTML event argument.
     * @param forceSave Save changes even when there are none according to the breeze service.
     */
    FormComponent.prototype.saveItem = function (event, forceSave) {
        var _this = this;
        if (forceSave === void 0) { forceSave = false; }
        this.validationErrors = [];
        this.draftAlert = false;
        if (this.item) {
            switch (this.item.entityType.shortName) {
                // When Appointment is modified and not Draft possible alert needed.
                case 'Appointment':
                    if (!this.item['Draft'] && this.item.entityAspect.entityState.isModified()) {
                        this.setOriginalResourceOid();
                        if (this.userService.html5role === 'employee') {
                            this.draftAlert = !this.settingsService.settings.suppressDraftAlert;
                        }
                    }
                    break;
                // When Appointment is modified and not Draft possible alert needed. (A plan item is never added.)
                case 'PlanItem':
                    var planItem = this.item;
                    if (planItem.ItemClass === 'Appointment' && planItem.Item && !planItem.Item['Draft'] && this.userService.html5role === 'employee') {
                        this.draftAlert = !this.settingsService.settings.suppressDraftAlert;
                    }
                    break;
                case 'Attendant':
                    if (!this.item.entityAspect.entityState.isModified()) {
                        break;
                    }
                    this.setOriginalResourceOid();
                    break;
                // A newly created Assignment from a form requires a corresponding Deployment and Demand.
                case 'Assignment':
                    if (this.item.entityAspect.entityState.isModified()) {
                        this.setOriginalResourceOid();
                        break;
                    }
                    if (this.item['Deployment'] != null || !this.item.entityAspect.entityState.isAdded()) {
                        break;
                    }
                    var demand = this.item['$Deployment.Demand'];
                    if (!demand) {
                        this.subscriptionPool.add(this.translateService.get('APP.DOMAIN.VALIDATORS.NEEDS_DEMAND').subscribe(function (value) {
                            _this.validationErrors.push(value);
                        }));
                        this.alertsService.createAlert('warning', 'APP.DOMAIN.VALIDATORS.NEEDS_DEMAND');
                        return;
                    }
                    if (event) {
                        event.target.classList.add('sym-working');
                    }
                    // If the assignment does not have a resource set yet, the current user's resource is assumed.
                    var deployment = this.breezeService.getEntityType('Deployment').createEntity({
                        Demand_Oid: demand['Oid'],
                        Resource_Oid: this.item['Resource_Oid'],
                        Start: demand['Start'],
                        Finish: demand['Finish'],
                        Color: this.item['Color'],
                        Name: this.item['Name'],
                        Customer_Oid: this.item['Customer_Oid']
                    });
                    this.item['Deployment'] = this.breezeService.addEntity(deployment);
                    break;
            }
        }
        _super.prototype.saveItem.call(this, event, forceSave);
    };
    /**
     * Set the original resource oid in a temporary property to enable an efficient planbord refresh.
     * @private
     * @memberOf FormComponent
     */
    FormComponent.prototype.setOriginalResourceOid = function () {
        var resourceOid = this.item.entityAspect.originalValues['Resource_Oid'];
        if (resourceOid) {
            this.item[PROP_ORIGINAL_RESOURCE_OID] = resourceOid;
        }
    };
    /**
     * Tries to get the entity with the specified key.
     * @protected
     * @param {string[]} The key of the entity to find.
     */
    FormComponent.prototype.tryGetItem = function (key) {
        var _this = this;
        if (this.entityType.shortName === 'PlanItem') {
            if (this.breezeService.isLoading) {
                this.isLoading = true;
                window.setTimeout(function () {
                    _this.tryGetItem(key);
                }, 500);
                return;
            }
        }
        _super.prototype.tryGetItem.call(this, key);
    };
    /**
     * Is called after saving.
     */
    FormComponent.prototype.doneSaving = function (newOrDeleted) {
        var _this = this;
        if (this.draftAlert) {
            var entity = this.item;
            switch (this.item.entityType.shortName) {
                case 'Appointment':
                    this.draftAlert = this.item['Draft'];
                    break;
                case 'PlanItem':
                    var planItem = this.item;
                    entity = planItem.Item;
                    this.draftAlert = entity['Draft'];
                    break;
            }
            if (this.draftAlert) {
                // Appointment changed to Draft.
                this.subscriptionPool.add(this.breezeService.getEntityByKey(entity.entityType, entity['Oid'], false).subscribe(function (result) {
                    // Check whether server has reverted Draft back to false.
                    if (result['Draft']) {
                        _this.alertsService.createAlert('info', 'APP.FORMS.ABSENCE_TO_DRAFT');
                    }
                }));
            }
        }
        _super.prototype.doneSaving.call(this, newOrDeleted);
    };
    return FormComponent;
}(FormBase));
export { FormComponent };
